module.exports = __webpack_public_path__ + "static/turtle-creek-house28-df48a3dfc020baf003dc448770606cb9.jpg";